import get from "lodash/get";
import { PropTypes } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { CommentWidget } from "../../comment-widget";
import "./commenting-widget.module.css";

class CommentingWidgetComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showComments: false
    };
    this.toggleComments = this.toggleComments.bind(this);
  }

  toggleComments(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showComments: !this.state.showComments });
  }

  commentsButton(text) {
    return (
      <div styleName="show-comments">
        <button onClick={this.toggleComments} styleName="show-comments-btn">
          {text}
        </button>
      </div>
    );
  }

  commentsWithButton() {
    return (
      <>
        {!this.state.showComments && this.commentsButton("Show Comments")}
        {this.state.showComments && <CommentWidget story={this.props.story} />}
        {this.state.showComments && this.commentsButton("Hide Comments")}
      </>
    );
  }

  render() {
    return this.props.hideComments ? this.commentsWithButton() : <CommentWidget story={this.props.story} />;
  }
}

function mapStateToProps(state) {
  return {
    hideComments: get(state, ["qt", "config", "theme-attributes", "comment-plugin", "hideComments"], false)
  };
}

CommentingWidgetComponent.propTypes = {
  hideComments: PropTypes.bool,
  story: PropTypes.object
};

export const CommentingWidget = connect(mapStateToProps)(CommentingWidgetComponent);
